<template>
  <modal
    name="global-confirm-modal"
    align="center"
    ref="modal"
  >
    <div class="modal__heading modal__item">
      <div class="modal__top-icon">
        <div class="square-icon color-warning">
          <icon icon-name="warning"></icon>
        </div>
      </div>
      <h3
        class="modal__title"
        v-html="title"
      >
      </h3>
      <div
        class="modal__subtitle"
        v-show="text"
        v-html="text"
      >
      </div>
    </div>
    <div class="modal__body modal__item">
      <button
        class="button button_lg button_secondary"
        @click.prevent="cancel"
      >
        <span class="button__text">{{ cancelText }}</span>
      </button>
      <button
        class="button button_lg button_primary"
        @click.prevent="confirm"
      >
        <span class="button__text">{{ confirmText }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue'

export default {
  name: 'ConfirmDialog',
  components: {
    Modal
  },
  data () {
    return {
      modal: null,
      title: null,
      text: null,
      cancelText: null,
      confirmText: null,
      onConfirm: null,
      onCancel: null
    }
  },
  methods: {
    init (props, onConfirm, onCancel) {
      const p = props || {}
      this.title = p.title || 'Вы уверены, что хотите продолжить?'
      this.text = p.text || ''
      this.cancelText = p.cancelText || 'Отмена'
      this.confirmText = p.confirmText || 'Продолжить'
      this.onConfirm = onConfirm
      this.onCancel = onCancel
      this.modal.open()
    },
    cancel () {
      if (this.onCancel) {
        this.onCancel()
      }
      this.close()
    },
    confirm () {
      if (this.onConfirm) {
        this.onConfirm()
      }
      this.close()
    },
    close () {
      this.modal.close()
    }
  },
  mounted () {
    this.modal = this.$refs.modal
    this.$root.confirmDialog = this.init
  }
}
</script>
